import React from 'react';

const Mail = ({ ...props }) => {
    return (
       <svg 
            width="16" 
            height="11" 
            viewBox="0 0 16 11" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clip-path="url(#clip0_11069_13635)">
                <path d="M0 0V11H16V0H0ZM14.44 1.4L8 4.45L1.56 1.4H14.44ZM14.6 9.6H1.4V2.87L8 6L14.6 2.87V9.6Z" fill="#222222"/>
            </g>
            <defs>
                <clipPath id="clip0_11069_13635">
                    <rect width="16" height="11" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Mail;
